import { useMutation } from '@tanstack/react-query';
import {
  submitBulkUploadFile,
  SubmitBulkUploadFileParams,
} from 'services/ClaimscoreApiService/Files';

export function useClaimsFileUpload() {
  return useMutation({
    mutationFn: (params: SubmitBulkUploadFileParams) => {
      return new Promise((resolve, reject) => {
        submitBulkUploadFile({
          ...params,
          onSuccess: (upload) => {
            resolve(upload);
          },
          onError: (error) => {
            reject(error);
          },
          onProgress: params.onProgress,
        });
      });
    },
  });
}
